import { Chance } from "chance"
import { DictionaryCategory } from "etl/types";

const chance = new Chance();

export const dictionaryCategoryFactoryMock = (howMany: number): DictionaryCategory[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/dictionaty_categories/${index + 1}`,
		"@type": "DictionaryCategory",
		id: index + 1,
		libelle: chance.word(),
		hb_category_id: chance.integer().toString(),
		hb_category_libelle: chance.word(),
	}));
